import { render, staticRenderFns } from "./ColStatus.vue?vue&type=template&id=1802e060&"
import script from "./ColStatus.vue?vue&type=script&lang=js&"
export * from "./ColStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports